<template>
  <tr v-if="!client.separator" class="clickable-row">
    <td><router-link :to="{ name: 'client_detail', params: { id: client.id }}">{{client.first_name}} {{client.last_name}}</router-link></td>
    <td class="text-right">
      <router-link :to="{ name: 'client_detail', params: { id: client.id }}"><a class="btn btn-default" href="" @click.stop.prevent="$emit('new-reservation-client-click', client.id)"><i class="las la-calendar-plus"></i>{{ $t('common.book') }}</a></router-link>

    </td>
  </tr>

  <tr v-else class="row-title">
    <td style="border:none;" colspan="2"><b>{{client.separator_letter}}</b></td>
  </tr>
</template>

<script>
export default {
  name: "ClientRow",
  props: {
    client: {
      type: Object,
      require: true
    }
  }
};
</script>
